module.exports = __webpack_public_path__ + "static/media/9.3020cd5a.JPG";